import { render, staticRenderFns } from "./ExpandableCheckbox.vue?vue&type=template&id=f7b2022e&"
import script from "./ExpandableCheckbox.vue?vue&type=script&lang=ts&"
export * from "./ExpandableCheckbox.vue?vue&type=script&lang=ts&"
import style0 from "./ExpandableCheckbox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
